(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bm-clean-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bm-clean-nav')) {
    customElements.define('bm-clean-nav', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.panels = [...this.querySelectorAll('.bm-nav__details')];
        this.panels.forEach(panel => {
          panel.addEventListener('toggle', () => {
            panel.querySelector('summary').setAttribute('aria-expanded', String(panel.open));
            if (panel.open) this.panels.forEach(other => { if (other !== panel) other.open = false; });
          }, options);
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const panel = event.target.closest('.bm-nav__details[open]');
          if (!panel) return;
          event.preventDefault();
          event.stopPropagation();
          panel.open = false;
          panel.querySelector('summary').focus();
        }, options);
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.panels.forEach(panel => { panel.open = false; });
        }, options);
        this.addEventListener('focusout', event => {
          if (this.classList.contains('bm-nav--desktop') && event.relatedTarget && !this.contains(event.relatedTarget)) {
            this.panels.forEach(panel => { panel.open = false; });
          }
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bm-cvr-safeguards"] && !Shopify.designMode) return;
  try {
    (() => {
  const marker = document.querySelector('[data-bm-cvr]');
  if (!marker) return;
  const sticky = document.querySelector('.bml-sticky, .product-sticky-add-bar');
  if (sticky) {
    const update = () => document.body.style.setProperty('--bm-cvr-sticky-height', Math.ceil(sticky.getBoundingClientRect().height) + 'px');
    new ResizeObserver(update).observe(sticky);
    update();
  }
  const purchase = document.querySelector('.product__buy-buttons');
  if (purchase && sticky?.matches('.product-sticky-add-bar')) {
    new IntersectionObserver(entries => {
      const entry = entries[0];
      sticky.classList.toggle('bm-purchase-passed', !entry.isIntersecting && entry.boundingClientRect.bottom <= 0);
    }).observe(purchase);
  }
  const targets = document.querySelectorAll('.product__buy-buttons, [id="SingleOptionSelector-0"], #bml-shop .bml-buy');
  const visible = new Set();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
    document.body.classList.toggle('bm-purchase-in-view', visible.size > 0);
  }, {rootMargin: '0px 0px -100px 0px'});
  targets.forEach(target => observer.observe(target));
  if (marker.hasAttribute('data-bm-bundle')) {
    const info = document.querySelector('[id^="ProductInfo-"]');
    if (!info) return;
    const syncReviews = () => {
      const badge = info.querySelector('.jdgm-prev-badge[data-number-of-reviews]');
      const label = badge?.querySelector('.jdgm-prev-badge__text');
      const count = Number(badge?.dataset.numberOfReviews);
      const rating = badge?.dataset.averageRating;
      if (!label || !Number.isFinite(count) || !rating) return;
      const text = rating + ' | ' + count.toLocaleString(document.documentElement.lang || 'en') + ' ' + marker.dataset.reviewLabel;
      if (label.textContent !== text) label.textContent = text;
    };
    new MutationObserver(syncReviews).observe(info, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['data-number-of-reviews','data-average-rating']});
    syncReviews();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
